import clsx from 'clsx';
import { badgeClassForTone } from '../lib/status.js';

// Server-supplied badges carry a legacy `tone`; lib/status.js maps tones onto the five status roles
// (and `teal` stays a tint, not a status). NOTE: which tone a given outcome gets is still decided
// server-side/per page (Phase 1 re-points those at statusFor), so e.g. a red "Declined" stays red
// until then. Keep the class mapping in status.js: tests/dashboard-tokens.test.js asserts it there.
export default function StatusBadge({ badge, className }) {
  if (!badge) return null;
  return (
    <span className={clsx('badge', badgeClassForTone(badge.tone), className)}>
      {badge.symbol ? <span>{badge.symbol}</span> : null}
      <span>{badge.label}</span>
    </span>
  );
}
